import { gql } from "shared/lib/graphql"
import { graphQueryBang } from "shared/lib/graphql"

const RecommendedAppletsQuery = gql`
  query {
    me {
      onboarding_applets {
        type
        id
        name
        config_type
        archived
        description
        icon_url
        monochrome_icon_url
        status
        service_slug
        brand_color
        installs_count
        author
        author_image_url
        author_tier
        run_count
        just_enabled
        last_run
        created_at
        updated_at
        author_id
        source_applet_id
        service_name
        by_service_owner
        instant
        speed
        is_tombstoned
        push_enabled
        can_push_enable
        pro_features
        published
        is_hidden
        requires_mobile_app
        requires_android_app
        requires_ios_app
        background_images {
          sm_background_image_url
          lg_background_image_url
          background_image_url_1x
          background_image_url_2x
          background_image_url_3x
        }
        channels {
          name
          module_name
          image_url
          variant_image_url
          monochrome_image_url
          brand_color
          available_to_everyone
        }
      }
    }
  }
`

const FinishOnboardingMutation = gql`
  mutation($channel_module_names: [String]) {
    finishOnboarding(input: { channel_module_names: $channel_module_names }) {
      errors {
        attribute
        message
      }
    }
  }
`

export const submitChannels = async (channel_module_names: any[]) => {
  const graphConfigs = { awaitClearCache: true }
  const {
    finishOnboarding: { errors },
  } = await graphQueryBang(
    FinishOnboardingMutation,
    {
      channel_module_names,
    },
    graphConfigs
  )

  return !errors.length
}

export const fetchRecommendedApplets = async (): Promise<any[]> => {
  const result = await graphQueryBang(RecommendedAppletsQuery)
  return result.me.onboarding_applets
}
